import type { LearningContentStatus } from '@mathflat/domain/@entities/StudentWorksheet/api2'

export const learningContentStatusText: Record<LearningContentStatus, string> = {
  INCOMPLETE: '학습가능',
  PROGRESS: '풀이중',
  COMPLETE: '학습완료',
  EXPIRED: '학습완료',
}

export const examLearningContentStatusText: Record<LearningContentStatus, string> = {
  INCOMPLETE: '미응시',
  PROGRESS: '응시중',
  COMPLETE: '제출완료',
  EXPIRED: '제출완료',
}

